// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__modal-body[data-v-42ebc83f]{font-size:14px;color:#6c757d}", ""]);
// Exports
module.exports = exports;
